import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import React__default from 'react';
import { api } from '@bilibili-maoer/web-utils';
import '../../../../../lazy-image/legacy-lazy-image/index.js';
import { SquareLazyImage } from '../../../../../lazy-image/lazy-image/index.js';
import { Loading, ELoadingType } from '../../../../../loading/index.js';
import '../../../../../scrollable/legacy-scrollable/index.js';
import { Scrollable } from '../../../../../scrollable/scrollable/index.js';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { getDramaFeed } from '../../../api/drama-feed.js';
import { createUseThrottleRequest, createUseMomizedScroll } from '../../../utils.js';
import { FailedNotice } from './notice.js';

var useThrottleRequest = createUseThrottleRequest();
var useMomizedScroll = createUseMomizedScroll();
var SubscribedDrama = function SubscribedDrama(_ref) {
  var _context6;

  var userId = _ref.userId;

  var _useThrottleRequest = useThrottleRequest({
    request: getDramaFeed
  }),
      data = _useThrottleRequest.data,
      loading = _useThrottleRequest.loading,
      success = _useThrottleRequest.success;

  var _useMomizedScroll = useMomizedScroll(),
      scrollRef = _useMomizedScroll.scrollRef,
      updateScrollPos = _useMomizedScroll.updateScrollPos;

  var renderSubscribedDrama = function renderSubscribedDrama() {
    var _data$info, _context;

    if (loading) {
      return /*#__PURE__*/React__default.createElement(Loading, {
        className: "history-loading",
        type: ELoadingType.MGirl
      });
    }

    if (!success) {
      return /*#__PURE__*/React__default.createElement(FailedNotice, null);
    }

    if (!(data !== null && data !== void 0 && (_data$info = data.info) !== null && _data$info !== void 0 && _data$info.data.length)) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "history-empty"
      }, "\u8FD8\u6CA1\u6709\u8FFD\u5267\u5462~");
    }

    return _mapInstanceProperty(_context = data.info.data).call(_context, function (item) {
      var _context2, _context3, _context4, _context5;

      return /*#__PURE__*/React__default.createElement("div", {
        key: item.id,
        className: "drama-item"
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "drama-cover-container",
        href: _concatInstanceProperty(_context2 = "".concat(api.MISSEVAN_SITE_MAIN, "/mdrama/")).call(_context2, item.id),
        target: "_blank"
      }, /*#__PURE__*/React__default.createElement(SquareLazyImage, {
        className: "drama-cover",
        src: item.cover
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "drama-info"
      }, /*#__PURE__*/React__default.createElement("a", {
        className: "drama-name",
        target: "_blank",
        href: _concatInstanceProperty(_context3 = "".concat(api.MISSEVAN_SITE_MAIN, "/mdrama/")).call(_context3, item.id),
        title: item.name
      }, item.name), item.saw_episode ? /*#__PURE__*/React__default.createElement("div", {
        className: "drama-last-saw"
      }, /*#__PURE__*/React__default.createElement("span", null, "\u4E0A\u6B21\u89C2\u770B\u81F3 "), /*#__PURE__*/React__default.createElement("a", {
        target: "_player",

        /**
         * TODO: web-utils api 支持获取播放页 sound url 前缀后，替换此处
         * Refs: https://www.tapd.bilibili.co/35612194/prong/stories/view/1135612194003066224
         */
        href: _concatInstanceProperty(_context4 = "".concat(api.MISSEVAN_SITE_MAIN, "/sound/")).call(_context4, item.saw_sound_id),
        title: item.saw_episode
      }, item.saw_episode)) : /*#__PURE__*/React__default.createElement("a", {
        target: "_blank",
        href: _concatInstanceProperty(_context5 = "".concat(api.MISSEVAN_SITE_MAIN, "/mdrama/")).call(_context5, item.id),
        className: "drama-not-saw"
      }, "\u5C1A\u672A\u6536\u542C")));
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: prependPrefix('popup')
  }, /*#__PURE__*/React__default.createElement(Scrollable, {
    className: prependPrefix('subscribed-drama-scrollable'),
    onScroll: updateScrollPos,
    ref: scrollRef
  }, renderSubscribedDrama()), /*#__PURE__*/React__default.createElement("a", {
    className: prependPrefix('more'),
    target: "_blank",
    href: _concatInstanceProperty(_context6 = "".concat(api.MISSEVAN_SITE_MAIN, "/")).call(_context6, userId, "/#/subscription")
  }, "\u67E5\u770B\u66F4\u591A"));
};

export { SubscribedDrama };
